import RecentSearchesRepository from './RecentSearchesRepository';
import { RecentSearchesStorage } from './types';

export default class RecentSearchesManager {
	storage: RecentSearchesStorage;

	constructor() {
		this.storage = new RecentSearchesRepository();
	}

	public getAll(): Promise<string[]> {
		return this.storage.getItems();
	}

	public add(newSearch: string): void {
		this.storage.addItem(newSearch);
	}
}
